import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';

import {
  fetchBCDatasets,
  clearSourceMessage,
  selectSource
} from '../../../../actions/synchronisationActions';
import { getOne } from '../../../../actions/storeActions';
import BCDatasetTable from './containers/BCDatasetTable';
import SourceSelector from '../../containers/SourceSelector';

const isBCSource = (source) =>
  !!source && typeof source.sourceType === 'string' && source.sourceType.startsWith('BUSINESSCENTRAL_');

class BCDataset extends React.Component {
  async componentDidMount() {
    const { currentStore, fetchStore } = this.props;
    if (currentStore.storeId) {
      fetchStore(currentStore.id);
      this.ensureBCSourceSelected();
      this.fetchAll();
    }
  }

  componentDidUpdate(prevProps) {
    const { currentStore, sourceId } = this.props;
    if (prevProps.currentStore.storeId !== currentStore.storeId || prevProps.sourceId !== sourceId) {
      this.ensureBCSourceSelected();
      this.fetchAll();
    }
  }

  /**
   * If the operator landed here with a non-BC source selected (e.g. Plytix from the Mappings tab),
   * switch them to the first available BC source so the table reflects BC data.
   */
  ensureBCSourceSelected() {
    const { sources, sourceId, selectSource } = this.props;
    const sourceList = Object.values(sources || {});
    if (sourceList.length === 0) return;
    const current = sourceId ? sources[sourceId] : null;
    if (current && isBCSource(current)) return;
    const firstBC = sourceList.find(isBCSource);
    if (firstBC && firstBC.id !== sourceId) {
      selectSource(firstBC.id);
    }
  }

  fetchAll() {
    const { currentStore, sourceId, fetchBCDatasets } = this.props;
    fetchBCDatasets(currentStore.storeId, sourceId);
  }

  onDismiss = () => {
    this.props.clearSourceMessage();
  };

  render() {
    const { currentStore, sourceId, message, isError } = this.props;

    return (
      <div className="mt-4">
        <SourceSelector filter={isBCSource} />
        <p className="text-muted small mb-3">
          Per-source overrides for Business Central dataset sync. Most rows are system defaults — add an
          override only when this tenant&apos;s gateway operation, ID field, or timestamp field differs from
          the default.
        </p>
        {message && (
          <Alert color={isError ? 'danger' : 'success'} isOpen={!!message} toggle={this.onDismiss}>
            {message}
          </Alert>
        )}

        <BCDatasetTable storeId={currentStore && currentStore.storeId} sourceId={sourceId} />
      </div>
    );
  }
}

export default connect(
  state => ({
    currentStore: state.store.one,
    sources: state.sync.source.sources,
    sourceId: state.sync.source.currentSourceId,
    message: state.sync.bcDataset.message,
    isError: state.sync.bcDataset.isError
  }),
  dispatch => ({
    fetchStore: storeId => dispatch(getOne(storeId)),
    fetchBCDatasets: (storeId, sourceId) => dispatch(fetchBCDatasets(storeId, sourceId)),
    selectSource: (sourceId) => dispatch(selectSource(sourceId)),
    clearSourceMessage: () => dispatch(clearSourceMessage())
  })
)(BCDataset);
